import { FormGroup } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";
import { bindActionCreators } from "redux";

import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import TextWidget from "common/form/widgets/TextWidget";
import * as paramsActions from "core/actions/paramsActions";
import * as userActions from "core/actions/userActions";
import Label from "core/components/label/Label";
import IResolverService from "core/service/resolver/IResolverService";
import ServiceRegistry from "core/util/ServiceRegistry";
import { ILinkType, IStaticLinkData, LinkTypeRegistry } from "../ILinkType";


interface ILanguageOption extends IStaticLinkData {
	language: string;
}

const languageOption: ILinkType<ILanguageOption> = {
	type: "language:option",
	label: "Language",
	icon: IconNames.TRANSLATE,
	renderInput: (value, onChange) => (
		<React.Fragment>
			<FormGroup label="Language Code">
				<TextWidget onChange={(language) => onChange({...value, language})} value={value.language} />
			</FormGroup>
			<FormGroup label="Label">
				<TextWidget onChange={(label) => onChange({...value, label})} value={value.label} />
			</FormGroup>
			<FormGroup label="Icon">
				<TextWidget onChange={(icon) => onChange({...value, icon})} value={value.icon} />
			</FormGroup>
			<FormGroup label="Icon Type">
				<ButtonSelect
					onChange={(iconType: "bp" | "external") => onChange({...value, iconType})}
					options={[
						{value: "bp", label: "Blueprint"},
						{value: "external", label: "External"}
					]}
					value={value.iconType || "bp"}
				/>
			</FormGroup>
		</React.Fragment>
	),
	mapDataToMenuNode: (data, {id}, state) => {

		const userLanguage = state.user.langauge;

		const o = {
			id,
			data,
			label: data.language ? <Label k={`language.${data.language}`} v={data.label} /> : "No Language Set",
			icon: undefined,
			isActive: userLanguage === data.language,
			attrs: {
				// TODO move this
				// this is for intel
				'data-wap_ref': data.label
			}
		};

		return o;
	},
	canAddChildren: false,
	doNavigate: (data, dispatch) => {
		if (data.language) {
			dispatch((d) => {
				ServiceRegistry.get(IResolverService)
					.clearCache()
					.then(() => {
						d(userActions.userSetLocale(data.language));
						d(paramsActions.forceQueryRefresh());
					});
			});
		}
	}
};

export default LinkTypeRegistry.registerType(languageOption);



// WEBPACK FOOTER //
// ./src/common/views/menuTree/linkTypes/LanguageOption.tsx